import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import classNames from 'classnames';
import Icon from '@helsenorge/designsystem-react/components/Icon';
import { theme, useHover } from '@helsenorge/designsystem-react';
import { getIcon } from './utils';
import styles from './styles.module.scss';
const ScoreInput = React.forwardRef(({ label, value, disabled, selected, expanded, onChange, ...rest }, ref) => {
    const { hoverRef, isHovered } = useHover();
    const id = `feedback-score-${value}`;
    return (_jsxs("label", { htmlFor: id, className: classNames(styles.scoreinput, selected && styles['scoreinput--selected']), ref: hoverRef, children: [_jsx("input", { type: "radio", value: value, disabled: disabled, "aria-expanded": expanded, className: styles.scoreinput__radio, id: id, ref: ref, onChange: onChange, ...rest }), _jsx(Icon, { svgIcon: getIcon(value), color: selected ? theme.palette.white : theme.palette.black, isHovered: isHovered }), _jsx("span", { className: styles.scoreinput__text, children: label })] }));
});
ScoreInput.displayName = 'ScoreInput';
export default ScoreInput;
